"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectCardTitle = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const ProjectCardTitle = (props) => {
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const projectData = projectsContext.getProjectData(props.projectApiKey);
    const badgeStatus = projectData.state.hasData ? "success" : "default";
    const projectTitleLink = React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.home(props.projectApiKey) }, props.projectName);
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Badge, { status: badgeStatus }),
        projectTitleLink);
};
exports.ProjectCardTitle = ProjectCardTitle;
